module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"tsunami\"-in-garden-grove-california-70d0703a04700b349da3b040e633db2d.png";